import { useNoIndex } from './model/useNoIndex'
import { SegmentedControl } from '../../shared/ui/controls/SegmentedControl'
import { GUIDE_PHASES, GUIDE_ROLES, GUIDE_ROLE_LABELS } from './model/topics'
import { useGuideRole } from './model/useGuideRole'
import { GuideLayout } from './ui/GuideLayout'
import { PhaseRail } from './ui/PhaseRail'
import { TopicCard } from './ui/TopicCard'

const UserGuidePage = () => {
  useNoIndex()
  const { role, setRole } = useGuideRole()
  const phases = GUIDE_PHASES[role]

  return (
    <GuideLayout>
      <h1 className="text-3xl font-bold text-gray-900">Anleitung</h1>
      <p className="mb-6 mt-1 text-base text-gray-600">Der Werkhof Schritt für Schritt — wählen Sie Ihre Rolle.</p>
      <SegmentedControl
        ariaLabel="Rolle"
        value={role}
        onChange={(v) => setRole(v)}
        items={GUIDE_ROLES.map((r) => ({ label: GUIDE_ROLE_LABELS[r], value: r }))}
      />
      <div className="mt-6">
        {phases.map((phase, i) => (
          <PhaseRail key={phase.title} number={i + 1} title={phase.title} isLast={i === phases.length - 1}>
            <div className="grid gap-3 sm:grid-cols-2">
              {phase.topics.map((t) => (
                <TopicCard key={t.slug} topic={t} />
              ))}
            </div>
          </PhaseRail>
        ))}
      </div>
    </GuideLayout>
  )
}

export default UserGuidePage
